import {Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomHttpResponse} from '../model/custom-http-response';
import { CACHE_ENABLED } from '../interceptor/cache.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  host = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getPublicSchedule(type: string): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/schedules/${type}`,
      {
        observe: 'response',
        context: new HttpContext().set(CACHE_ENABLED, false)
      }
    )
  }
}
